// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M5.18903 5.5H9V7.5H5V9.5H9V11.5H5V13C5 13.1682 5.00695 13.335 5.02059 13.5H9V15.5H5.54436C6.49234 17.5655 8.57787 19 11 19V20H6V22H18V20H13V19C15.4221 19 17.5077 17.5655 18.4556 15.5H15V13.5H18.9794C18.9931 13.335 19 13.1682 19 13V11.5H15V9.5H19V7.5H15V5.5H18.811C18.1449 2.91216 15.7958 1 13 1H11C8.20424 1 5.85509 2.91216 5.18903 5.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-microphone-filled')
export default class MicrophoneFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'microphone-filled',
    }
  }
}
